import { NavLink, useLocation } from "react-router-dom";
import AnimateHeight from "react-animate-height";
import { motion } from "framer-motion";
import useUtils from "@/hooks/useUtils";
import { NavItemRevampPropTypes } from "./propTypes";

const NavItemRevamp = ({ subNavItem, isOpened }) => {
  const { convertToRelative, isExternal } = useUtils();
  const location = useLocation();
  const { pathname, search, hash } = location;

  const linkStyle = (isPending, menuLink) => {
    const currentUrl = pathname + search + hash;
    const relativeUrl = convertToRelative(menuLink);
    const isCurrent = currentUrl == relativeUrl;

    return {
      fontWeight: isCurrent ? "bold" : "",
      color: isPending ? "#ccc" : "",
      pointerEvents: isCurrent || isPending ? "none" : "",
    };
  };

  return (
    <AnimateHeight
      duration={350}
      height={isOpened ? "auto" : 0}
      className="relative lg:absolute lg:left-0 lg:top-full lg:shadow-[2px_4px_12px_0px_rgba(0,0,0,0.15)] lg:after:content-[''] lg:after:absolute lg:after:-top-[10px] lg:after:right-[calc(50%_-_5px)] lg:after:left-auto lg:after:w-0 lg:after:h-0 lg:after:border-l-[5px] lg:after:border-t-0 lg:after:border-t-transparent lg:after:border-l-transparent lg:after:border-r-[5px] lg:after:border-r-transparent lg:after:border-b-[10px] lg:after:border-b-site_air lg:after:border-solid lg:after:shadow-lg"
    >
      <motion.div
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: isOpened ? 1 : 0, y: isOpened ? 0 : -6 }}
        transition={{ duration: 0.25, ease: [0.22, 0.61, 0.36, 1] }}
      >
        <div className="subitems flex flex-col items-start lg:bg-gray-300 lg:w-[173px] bg-white/70 shadow-sm ring-1 ring-white/20">
          {subNavItem.map((subMenu) => {
            return (
              <NavLink
                key={subMenu.id}
                className={"menu-item-revamp link-nav p-4 w-full lg:hover:bg-gray-300"}
                style={({ isPending }) => {
                  return linkStyle(isPending, subMenu.url);
                }}
                to={convertToRelative(subMenu.url)}
                target={isExternal(subMenu.url) ? "_blank" : "_self"}
              >
                <span dangerouslySetInnerHTML={{ __html: subMenu.content }}></span>
              </NavLink>
            );
          })}
        </div>
      </motion.div>
    </AnimateHeight>
  );
};

NavItemRevamp.propTypes = NavItemRevampPropTypes;

export default NavItemRevamp;
